import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import { __DEV__ } from '../../../utils/assertion.esm.js';
import '../../../utils/ssr.esm.js';
import '../../../utils/number.esm.js';
import '../../../utils/array.esm.js';
import '../../../utils/breakpoint.esm.js';
import '../../../utils/context.esm.js';
import '../../../utils/dom.esm.js';
import '../../../utils/tabbable.esm.js';
import '../../../utils/dom-query.esm.js';
import '../../../utils/logger.esm.js';
import '../../../utils/focus.esm.js';
import '../../../utils/function.esm.js';
import '../../../utils/keydown.esm.js';
import '../../../utils/lazy.esm.js';
import '../../../utils/object.esm.js';
import '../../../utils/react-helpers.esm.js';
import '../../../utils/style-props.esm.js';
import '../../../utils/tailwind.esm.js';
import Box from '../../Box/index.esm.js';
import Transition from '../../Transition/index.esm.js';
import { useModalContext } from '../context.esm.js';

var ModalContent = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var _props$as = props.as,
      as = _props$as === void 0 ? 'section' : _props$as,
      children = props.children,
      unstyled = props.unstyled,
      _props$enter = props.enter,
      enter = _props$enter === void 0 ? ['ease-out', 'duration-300'] : _props$enter,
      _props$enterFrom = props.enterFrom,
      enterFrom = _props$enterFrom === void 0 ? ['opacity-0', 'sm:scale-95'] : _props$enterFrom,
      _props$enterTo = props.enterTo,
      enterTo = _props$enterTo === void 0 ? ['opacity-100', 'sm:scale-100'] : _props$enterTo,
      _props$leave = props.leave,
      leave = _props$leave === void 0 ? ['ease-in', 'duration-200'] : _props$leave,
      _props$leaveFrom = props.leaveFrom,
      leaveFrom = _props$leaveFrom === void 0 ? ['opacity-100', 'sm:scale-100'] : _props$leaveFrom,
      _props$leaveTo = props.leaveTo,
      leaveTo = _props$leaveTo === void 0 ? ['opacity-0', 'sm:scale-95'] : _props$leaveTo,
      rest = _objectWithoutPropertiesLoose(props, ["as", "onClick", "children", "unstyled", "enter", "enterFrom", "enterTo", "leave", "leaveFrom", "leaveTo"]);

  var _useModalContext = useModalContext(),
      getContentProps = _useModalContext.getContentProps,
      getOverlayProps = _useModalContext.getOverlayProps,
      size = _useModalContext.size;

  var contentProps = getContentProps(_extends({}, rest, {
    ref: ref
  }));
  var overlayProps = getOverlayProps();
  var wrapperStyleProps = {
    padding: ['p-4', 'md:p-6', 'lg:p-8'],
    alignItems: 'items-center'
  };
  var contentStyleProps = {
    margin: 'm-auto',
    maxHeight: 'max-h-(screen-20)',
    outline: 'outline-none',
    borderRadius: 'rounded-xl',
    boxShadow: 'shadow-lg'
  };

  if (unstyled) {
    wrapperStyleProps = {};
    contentStyleProps = {};
  }

  return (// TODO: inject overlayProps which containing onClose method because the layer has
    // a higher zIndex than the real overlay so it will prevent the overlay from being clicked
    // note here as We should be able to have a better way to handle this
    React__default.createElement(Box, _extends({
      position: "fixed",
      inset: "inset-0",
      zIndex: "z-50",
      display: "flex"
    }, overlayProps, wrapperStyleProps), React__default.createElement(Transition, {
      enter: enter,
      enterFrom: enterFrom,
      enterTo: enterTo,
      leave: leave,
      leaveFrom: leaveFrom,
      leaveTo: leaveTo
    }, React__default.createElement(Box, _extends({
      as: as,
      position: "relative",
      zIndex: "z-50",
      flex: "flex-1",
      display: "flex",
      overflow: ['overflow-auto', 'scrolling-touch'],
      flexDirection: "flex-col",
      width: "w-full",
      maxWidth: size,
      backgroundColor: "bg-white",
      transitionProperty: "transition-all",
      transform: "transform"
    }, contentProps, contentStyleProps, rest), children)))
  );
});

if (__DEV__) {
  ModalContent.displayName = 'ModalContent';
}

export default ModalContent;
//# sourceMappingURL=index.esm.js.map
